module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page17",
      "title": "17"
    }
  }, [_c('h1', {
    staticClass: "sb-title"
  }, [_c('span', {
    staticClass: "clr_blue"
  }, [_vm._v("TEN TIPS")]), _c('span', {
    staticClass: "blueh"
  }, [_vm._v(" FOR NEW OR TEST-RUN VEGANS")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "dropcap blueh"
  }, [_vm._v("1")]), _vm._v(" "), _c('strong', {
    staticClass: "list-leadin"
  }, [_vm._v("Play.")]), _vm._v(" Experiment with a wide variety of new and known vegan foods. Make it a habit to buy at least one “new” food at the grocery store or farmers’ market each week.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "dropcap blueh"
  }, [_vm._v("2")]), _vm._v(" "), _c('strong', {
    staticClass: "list-leadin"
  }, [_vm._v("Cook.")]), _vm._v(" Get in the kitchen and cook. Try different methods of preparation for foods new and familiar.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "dropcap blueh"
  }, [_vm._v("3")]), _vm._v(" "), _c('strong', {
    staticClass: "list-leadin"
  }, [_vm._v("Read.")]), _vm._v(" Feed your craving for knowledge by reading cookbooks and other vegan lifestyle books. The bookstore shelves (real and virtual) are filled with talented vegan authors!")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "dropcap blueh"
  }, [_vm._v("4")]), _vm._v(" "), _c('strong', {
    staticClass: "list-leadin"
  }, [_vm._v("Explore.")]), _vm._v(" Taste test, shop around, dine out. Start out by trying a wide variety of plantbased whole foods, brands, and products, recipes, and restaurants. Every city usually has at least one “veg-friendly” restaurant. Try it! But even go to mainstream restaurants and challenge the chef to create something plantbased for you. Food is a social thing, so you will need to get used to discussing your vegan status when dining out with friends. Work on shedding your shyness. Be proud of the positive lifestyle changes you are embracing.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "dropcap blueh"
  }, [_vm._v("5")]), _vm._v(" "), _c('strong', {
    staticClass: "list-leadin"
  }, [_vm._v("Talk.")]), _vm._v(" Share your new diet with anyone who will listen. Hopefully you will find at least one supportive friend or family member who will act as a cheerleader (or even join you) as you experiment with vegan living.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "dropcap blueh"
  }, [_vm._v("6")]), _vm._v(" "), _c('strong', {
    staticClass: "list-leadin"
  }, [_vm._v("Reach.")]), _vm._v(" Embrace community. Read blogs to hear others’ experiences and pitfalls. Check out my website "), _c('a', {
    attrs: {
      "href": "http://FindingVegan.com",
      "target": "_blank"
    }
  }, [_vm._v("FindingVegan.com")]), _vm._v(" to browse recipes by talented vegan bloggers. Or stop by my blog, "), _c('a', {
    attrs: {
      "href": "http://HealthyHappyLife.com",
      "target": "_blank"
    }
  }, [_vm._v("HealthyHappyLife.com")]), _vm._v(". Tweet @lunchboxbunch or say hi to me online! I am eager to help in any way I can, as are many vegan bloggers online. Seek out fellow vegans in person or online so that you do not feel so alone during this transition.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "dropcap blueh"
  }, [_vm._v("7")]), _vm._v(" "), _c('strong', {
    staticClass: "list-leadin"
  }, [_vm._v("Tune in.")]), _vm._v(" Pay attention to your body and see what foods work for you. Because above all, remember that everyone is different. Each of us will respond to foods differently, so paying attention is your key to success. Realize that each new meal is an experiment.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "dropcap blueh"
  }, [_vm._v("8")]), _vm._v(" "), _c('strong', {
    staticClass: "list-leadin"
  }, [_vm._v("Write.")]), _vm._v(" Write it down. Start a food diary. Or download a smartphone app that helps you track what you eat and allows you to make notes about how you respond to certain meals.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "dropcap blueh"
  }, [_vm._v("9")]), _vm._v(" "), _c('strong', {
    staticClass: "list-leadin"
  }, [_vm._v("Seek expert advice.")]), _vm._v(" Consult a doctor or dietitian. Each person has varying nutritional needs, so checking in with your physician or starting a relationship with a vegan-friendly dietician is key to your journey. A doctor will be able to test your levels of important nutrients like vitamin D and vitamin B12 and more. One of my favorite vegan dieticians and authors is Ginny Messina, RD.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "dropcap blueh"
  }, [_vm._v("10")]), _vm._v(" "), _c('strong', {
    staticClass: "font6"
  }, [_vm._v("Find your yum.")]), _vm._v(" Huh you say? What this means is that everyone has different favorite recipes. Start off your mealtime exploration by veganizing your favorite non-vegan meals. Or look for vegan recipes that are similar to your favorites. Next, keep an eye out for brand-new meals that make you swoon. Once you discover your favorite vegan foods, you can create a cornerstone set of go-to meals that will keep your vegan diet humming along quite easily.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4353574c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/page017.vue
// module id = 81
// module chunks = 0